module.exports = __webpack_public_path__ + "img/IMAGE 9.0b6dc531.png";